export enum TipoPregunta {
	Abierta = 1,
	Unica = 3,
	Multiple = 2,
  ListaValor = 4,
  Formula = 5,
}
